import { Button, Divider, Stack, Typography } from "@mui/material";
import ProfileAndCommentComponent from "./ProfileAndCommentComponent";
import PostCommentAndLikesShareComponent from "./PostCommentAndLikesShareComponent";

function FourthSectionAppHome() {
  return (
    <Stack
      direction="column"
      id="create-post"
      sx={{
        bgcolor: "#ffffff",
        borderRadius: "24px",
        px: "20px",
        py: "16px",
      }}
    >
      {" "}
      <ProfileAndCommentComponent
        avatarSrc="/images/Annette-Black.jpeg"
        primaryText="Annette Black"
        secondaryText="5 days ago"
        profile={true}
        bluetick={true}
        menuOrImojiButton={{ src: "/icons/3dotsmenu.svg" }}
        postDescription={true}
      >
        <Typography variant="body2" sx={{ pb: "12px" }}>
          Apple CEO Tim Cook’s latest visit to London, on Wednesday, Dec. 11,
          was an opportunity to emphasize the company’s commitment to London and
          the U.K. Apple’s investment in the U.K. has been over $22 billion or
          £18 billion in the last five years, the company says. Cook was here as
          part of a bigger visit which culminated on Thursday, Dec. 12, in
          welcoming King Charles III to Apple’s Battersea HQ. When I was there,
          I saw Cook beaming and the king relaxed and engaged.
        </Typography>
        <Typography variant="body2">
          hile he talked to young people at Caius House, a youth center near
          Apple’s London HQ in Battersea, he was candid and open about his life
          and Apple’s latest features. Delrita Agyapong, CEO of Caius House told
          me how valuable Apple was to them. “We work with young people in
          Battersea, giving them support with improving their digital skills and
          helping them to reach their potential. It’s great to have Apple in the
          local community and, with their support, we’ve been able to give young
          people the opportunity to work with the latest technology and learn
          from experts about how to put theory into practice,”{" "}
        </Typography>
        <Typography variant="body2" sx={{ pb: "6px" }}>
          she said. And in terms of experts, it’s hard to imagine someone better
          qualified than Cook — and the reaction when the Caius House surprise
          visitor was revealed to be Cook was palpable excitement.
        </Typography>
      </ProfileAndCommentComponent>
      <PostCommentAndLikesShareComponent />
      <ProfileAndCommentComponent
        avatarSrc="/images/Annette-Black.jpeg"
        primaryText="Annette Black"
        secondaryText="5 days ago"
        bluetick={true}
        menuOrImojiButton={{ src: "/icons/heart-emoji.svg", text: "02" }}
        // postDescription={false}
        commentDescription={true}
      >
        <Typography variant="body2">
          Hi my name is Sharon Mosby, I’m a Arkansas inventor looking for advice
          from a investor. I have a patent number on a idea that I came up with.
          Thanks!
        </Typography>
      </ProfileAndCommentComponent>
      {/* {hideReply && (
          <> */}
      <ProfileAndCommentComponent
        replyLeftPadding="60px"
        menuOrImojiButton={{ text: "2 Hours Ago" }}
        reply={true}
        avatarSrc="/images/Annette-Black.jpeg"
        primaryText="Annette Black"
        commentDescription={true}
        secondaryText="Hi my name is Sharon Mosby, I’m a Arkansas inventor looking for advice
          from a investor. I have a patent number on a idea that I came up with.
          Thanks! Hi my name is Sharon Mosby, I’m a Arkansas inventor looking for advice
          from a investor. I have a patent number on a idea that I came up with.
          Thanks!"
      ></ProfileAndCommentComponent>
      {/* {hideReply2 && ( */}
      <ProfileAndCommentComponent
        replyLeftPadding="120px"
        menuOrImojiButton={{ text: "2 Hours Ago" }}
        reply={true}
        avatarSrc="/images/Annette-Black.jpeg"
        primaryText="Annette Black"
        commentDescription={true}
        secondaryText="Hi my name is Sharon Mosby, I’m a Arkansas inventor looking for advice
          from a investor. I have a patent number on a idea that I came up with.
          Thanks! Hi my name is Sharon Mosby, I’m a Arkansas inventor looking for advice
          from a investor. I have a patent number on a idea that I came up with.
          Thanks!"
      ></ProfileAndCommentComponent>
      <Divider
        sx={{
          height: ".5px",
          //   maxWidth: "700px",
          //   minWidth: "100px",
          bgcolor: "#E5E5E5",
          mx: "-20px",
          my: "30px",
          maxWidth: "650px",
          border: "none",
        }}
      />
      <ProfileAndCommentComponent
        avatarSrc="/images/Annette-Black.jpeg"
        primaryText="Annette Black"
        secondaryText="5 days ago"
        // bluetick={true}
        menuOrImojiButton={{ src: "/icons/heart-emoji.svg", text: "02" }}
        // postDescription={false}
        commentDescription={true}
        onlyReply={true}
      >
        <Typography variant="body2">
          Hi my name is Sharon Mosby, I’m a Arkansas inventor looking for advice
          from a investor. I have a patent number on a idea that I came up with.
          Thanks!
        </Typography>
      </ProfileAndCommentComponent>
      <Divider
        sx={{
          height: ".5px",
          //   maxWidth: "700px",
          //   minWidth: "100px",
          bgcolor: "#E5E5E5",
          mx: "-20px",
          my: "30px",
          maxWidth: "650px",
          border: "none",
        }}
      />
      <ProfileAndCommentComponent
        avatarSrc="/images/Annette-Black.jpeg"
        primaryText="Annette Black"
        secondaryText="5 days ago"
        // bluetick={true}
        menuOrImojiButton={{ src: "/icons/heart-emoji.svg", text: "02" }}
        // postDescription={false}
        commentDescription={true}
        onlyReply={true}
      >
        <Typography variant="body2">
          Hi my name is Sharon Mosby, I’m a Arkansas inventor looking for advice
          from a investor. I have a patent number on a idea that I came up with.
          Thanks!
        </Typography>
      </ProfileAndCommentComponent>
      <Button
        variant="text"
        sx={{
          alignSelf: "start",
          width: "auto",
          minWidth: "0",

          color: "#9C9C9C",
          "&:hover": {
            backgroundColor: "transparent",
            boxShadow: "none",
          },
          "&:active": {
            backgroundColor: "transparent",
            boxShadow: "none",
          },
          "&:focus": {
            outline: "none",
          },
          textTransform: "none",
          p: "0px",
          pt: "30px",
        }}
      >
        Show 5 more Comments ...
      </Button>
    </Stack>
  );
}

export default FourthSectionAppHome;
